import { useQueryClient, useQuery, useMutation } from '@tanstack/react-query';
import { notification, Button, Row, Col, Table, Modal, Input } from 'antd';
import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import PageTitle from '../../components/page-title';
import { getLanguages, deletePlaceholder, getMessages } from '../../services/api';
import { DeleteOutlined, FileAddOutlined } from '@ant-design/icons';
import ModalMessage from '../../components/modal-message';
const { Search } = Input;

const Messages = () => {
    const queryClient = useQueryClient();
    const [ searchTerm, setSearchTerm ] = useState('');
    const [ ntf, contextHolder ] = notification.useNotification();
    const { data, isFetched } = useQuery(['messages', {search: searchTerm}], () => getMessages(), {select: (data) => {
      /* const filteredData = data && data.data.filter((item: any) =>
        item.message.toLowerCase().includes(searchTerm.toLowerCase())
      );
      console.log(filteredData); */
      return data;
    }});

    const { mutate: mutateDeletePlaceholder } = useMutation(deletePlaceholder)
    const [ isOpenDeleteArticleModal, setisOpenDeleteArticleModal ] = useState({open: false, id: 0});
    const [ isOpenMessageModal, setIsOpenMessageModal ] = useState({open: false, id: 0});
  
    const handleDelete = () => {
      mutateDeletePlaceholder({id: isOpenDeleteArticleModal.id}, {
        onSuccess() {
          queryClient.invalidateQueries(['placeholders']);
          setisOpenDeleteArticleModal({open: false, id: 0});
          ntf.success({
            message: `Success`,
            description: "Blog is deleted with success!",
            placement: "bottomLeft",
          });
        },
        onError() {
          ntf.error({
            message: `Error`,
            description: "Something gonne wrong!",
            placement: "bottomLeft",
          });
        },
      })
    }
  
    const columns: any = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (key: string, record: any) => <Button onClick={() => setIsOpenMessageModal({open: true, id: record.id})}>Otvori poruku od: {key}</Button> 
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email'
      },
      {
        title: 'Date Added',
        dataIndex: 'date_added',
        key: 'date_added'
      },
      {
        title: 'Delete',
        dataIndex: 'delete',
        key: 'delete',
        align: 'center',
        width: '50px',
        render: (id: any, record: any) => <Button icon={<DeleteOutlined />} danger onClick={() => setIsOpenMessageModal({open: true, id: record.id})} />
      },
    ];
    
    
    return (
      <Row justify="center">
        {contextHolder}
        <PageTitle text={`Messages`} />
        <Col span={20}>
            <Row gutter={24} justify={'center'}>
                <Col>
                    <Search
                      placeholder="Search by message"
                      onSearch={(value) => setSearchTerm(value)}
                      style={{ width: 300 }}
                    />
                </Col>
            </Row>
        </Col>
        <Col span={20}>
          <Table dataSource={isFetched ? data.data : []} columns={columns} pagination={false} rowKey='id'/>;
        </Col>
        <Modal title="Delete Blog?" open={isOpenDeleteArticleModal.open} onOk={() => handleDelete()} onCancel={() => setisOpenDeleteArticleModal({open: false, id: 0})}>
          Do you really want to delete it?
        </Modal>
        {isOpenMessageModal.open && <ModalMessage id={isOpenMessageModal.id} isOpen={isOpenMessageModal.open} onClose={() => setIsOpenMessageModal({open: false, id: 0})} />}
      </Row>
    )
}

export default Messages